import React, { useState, useEffect } from "react";

export default function GalleryPage() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const galleryPosts = posts.filter(post => post.type === "pictureVideo");

  useEffect(() => {
    const fetchGalleryFeed = async () => {
      try {
        setIsLoading(true);

        const backendUrl = process.env.REACT_APP_BACKEND_API_URL;
        if (!backendUrl) {
          throw new Error("Backend API URL is not defined.");
        }

        const response = await fetch(`${backendUrl}/api/nfts`);
        if (!response.ok) {
          throw new Error("Failed to fetch feed posts");
        }

        const data = await response.json();

        const castlesFollowed = []; // Replace with real data
        const filteredPosts = castlesFollowed.length
          ? data.filter((post) => castlesFollowed.includes(post.castleId))
          : data;

        setPosts(filteredPosts);
      } catch (err) {
        console.error("Error fetching feed posts:", err);
        setError("Failed to load feed posts. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchGalleryFeed();
  }, []);

  if (isLoading) {
    return <div className="text-center text-white">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-red-500">{error}</div>;
  }

  return (
    <div className="min-h-screen bg-brandBlack text-brandWhite p-6">
      <h1 className="text-4xl font-gothic text-center mb-6">GALLERY</h1>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {galleryPosts.map((post) => (
          <div key={post.id || post._id} className="border border-gray-700 rounded overflow-hidden">
            {post.image && (
              <img
                src={post.image}
                alt={post.title || "Untitled"}
                className="w-full h-auto object-cover"
              />
            )}
            {post.video && (
              <video controls className="w-full">
                <source src={post.video} type="video/mp4" />
              </video>
            )}
            <div className="p-2 text-center font-gothic text-white border-t border-gray-400">
              {post.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
